import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TCreateGoldConversionReduxParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';

export default function* watchCreateGoldConversion(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldCreateGoldConversionAttempt', handleCreateGoldConversion, api);
}

function* handleCreateGoldConversion(api: GoldGateway, action: PayloadAction<TCreateGoldConversionReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        draftId,
    } = action.payload;

    const response = yield* call([api, api.createGoldConversion], {
        authToken,
        draftId,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldCreateGoldConversionFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        toast.success(SuccessMessages.GoldCreateConversionSuccess);
        yield put(combinedActions.goldSetIsCreateGoldConversionModalOpen(false));
        yield put(combinedActions.goldCreateGoldConversionSuccess());
        yield put(combinedActions.goldGetGoldConversionListingAttempt());
        yield put(combinedActions.goldSetIsFormFilled(false));
    }
}
